import { LoadingLayout } from 'components';
import { useScrollToTop } from 'hooks/useScrollToTop';
import { ErrorFallback } from 'modules/App/ErrorFallback';

import { getLegalClientBeneficiaryMainInfo } from '../helpers/getLegalClientBeneficiaryMainInfo';
import { useLegalClientBeneficiary } from '../hooks';
import { LegalClientBeneficiaryView } from '../views/LegalClientBeneficiaryView';

export const LegalClientBeneficiaryContainer = () => {
  const {
    loading,
    legalClientBeneficiary,
    countries,
    countriesLoading,
    error,
    initialValues,
    submitLoading,
    breadcrumbsTitles,
    deleteLoading,
    resendVerificationEmailTime,
    changeEmailLoading,
    changeEmailError,
    archiveLoading,
    dearchiveLoading,
    revokeOtpVerificationLoading,
    onChangeEmail,
    lockClientIfPossible,
    unlockClient,
    onSubmit,
    onShowVersionHistory,
    onDelete,
    onSendVerificationEmail,
    onArchive,
    onDearchive,
    onRevokeOtpVerification,
  } = useLegalClientBeneficiary();

  useScrollToTop([]);

  if (error || (!legalClientBeneficiary && !loading)) {
    return <ErrorFallback />;
  }

  if (loading || !legalClientBeneficiary) {
    return <LoadingLayout />;
  }

  const mainInfo = getLegalClientBeneficiaryMainInfo(legalClientBeneficiary);

  return (
    <LegalClientBeneficiaryView
      archiveLoading={archiveLoading}
      breadcrumbsTitles={breadcrumbsTitles}
      changeEmailError={changeEmailError}
      changeEmailLoading={changeEmailLoading}
      countries={countries}
      countriesLoading={countriesLoading}
      dearchiveLoading={dearchiveLoading}
      deleteLoading={deleteLoading}
      initialValues={initialValues}
      kycData={legalClientBeneficiary.kyc}
      lockClientIfPossible={lockClientIfPossible}
      mainInfo={mainInfo}
      resendVerificationEmailTime={resendVerificationEmailTime}
      revokeOtpVerificationLoading={revokeOtpVerificationLoading}
      submitLoading={submitLoading}
      unlockClient={unlockClient}
      onArchive={onArchive}
      onChangeEmail={onChangeEmail}
      onDearchive={onDearchive}
      onDelete={onDelete}
      onRevokeOtpVerification={onRevokeOtpVerification}
      onSendVerificationEmail={onSendVerificationEmail}
      onShowVersionHistory={onShowVersionHistory}
      onSubmit={onSubmit}
    />
  );
};
